(function(smarket, ko, $) {
  'use strict';
  // 过滤
  var filter = {
    // 过滤文件类型
    fileType: function(ext) {
      var list = [
        {key: 'word', category: 'word'}, {key: 'docx', category: 'word'}, {key: 'doc', category: 'word'},
        {key: 'xls', category: 'excel'}, {key: 'xlsx', category: 'excel'}, {key: 'csv', category: 'excel'},
        {key: 'ppt', category: 'ppt'}, {key: 'pptx', category: 'ppt'}, {key: 'mp3', category: 'music'},
        {key: 'amr', category: 'music'}, {key: 'jpg', category: 'picture'}, {key: 'bmp', category: 'picture'},
        {key: 'gif', category: 'picture'}, {key: 'jpeg', category: 'picture'}, {key: 'psd', category: 'picture'},
        {key: 'png', category: 'picture'}, {key: 'tiff', category: 'picture'}, {key: 'svg', category: 'picture'},
        {key: 'mp4', category: 'video'}, {key: 'mpeg', category: 'video'}, {key: 'avi', category: 'video'},
        {key: 'zip', category: 'rar'}, {key: 'rar', category: 'rar'}, {key: 'zipx', category: 'rar'},
        {key: 'iso', category: 'rar'}, {key: 'bz', category: 'rar'}, {key: 'tar', category: 'rar'},
        {key: 'pdf', category: 'pdf'}, {key: '文件夹', category: 'folder'}, {key: '*', category: 'unknown'}
      ];
      return list.filter(function(item) {
        return ext === item.key || item.key === '*';
      })[0].category;
    },
    exclude: function(obj, afterFun) {
      for (var i in obj) {
        if (obj.hasOwnProperty(i) && ( obj[i] === '' || obj[i] === undefined)) {
          delete obj[i];
        }
      }
      if (typeof afterFun === 'function') {
        afterFun(obj);
      }
      return obj;
    }
  };
  var smarketSpi = smarket.api,
      filesb = smarketSpi.filesb = smarketSpi.filesb || {};
    var  comment = smarket.api.comment;
    function postJSON(url,data,success){
        return smarket.api.s3g(url,data,success);
    }
    comment.interactionCreate=function(data){
        return postJSON('/api/article/interaction/create',data)
    }
    //获取粉丝真实wechatid 下载邮箱用
    filesb.getContact=function(data){
        return postJSON('/api/wechat/contacts/get',data)
    };
    //获取粉丝用户信息 下载邮箱用
    filesb.getWechat = function(data){
        return postJSON('/api/wechat/get',data)
    };

    function addWeChatInfo(url, data) {
        if (!('weChatId' in data)) {
            data.weChatId = smarket.urlParams.weChatId
        }
    }
    var url = ['article/getDetail'];
    smarket.registerRulesListHandler(addWeChatInfo, url);

    //裂变模块选择图文加参数 全员营销加参数
    smarket.registerRulesListHandler(function(url,data){
      data.markCode = smarket.urlParams.markCode;
      data.marketingSess = $.cookie('marketingSess');
      data.taskId = smarket.urlParams.marketingTaskId;
      data.browseInfo = activeRecord.browseInfo;
    }, ['/article/browse']);

  var weChatId, // 获取微信身份，所使用的weChatId
      unusedWeChatId, // 标明文章行为记录的实例id
      articleId = smarket.urlParams.articleId,
      articleContent,
      realWeChatId,
      markCode = smarket.urlParams.markCode || '',
      own = {
        session: '',
        memberId: 0,  //体系人员Id
        globalUserId: smarket.cookie.globalUserId(),
        openId: '' // 优先cookie里的，其次获取到的存到cookie里，在其次是url里带的ocode参数
      };
  var configSet='';
  var tenantId='';
  var instanceId='';
  var moduleId='';
  var actionKey1='';
  var vm = new smarket.viewModel.ArticleViewModel(smarket.urlParams.articleId);

  //全员营销模板使用
  vm.isWeChat = ko.observable(smarket.inWeChat);
  var cardUrl = smarket.urlParams.cardUrl ?smarket.urlParams.cardUrl :'';
  vm.fullMarketPageUrl = ko.observable(cardUrl);
  vm.shareCon = ko.observable({});
  window.addEventListener('message', function(e){
    if(e.data.fullMarketAlertShareVal){
      vm.shareCon(e.data.fullMarketAlertShareVal);
      $('#share-tip').show();
    }
    if(e.data == 'hide'){
      $('.fullMarketIframe').hide();
    }
  });
  vm.closeModal = function(){
    $('#share-tip').hide();
  };

  if(smarket.urlParams.marketingTaskId){
    // 封装一下push历史记录的方法
    function pushHistory() {
      window.history.pushState('forward', null, '#');
    }
    window.addEventListener("popstate", function() {
      history.back();
      history.back();
      history.go(-1);
    }, false);
    // 在需要监听的页面执行该方法
    pushHistory();
  }



  //重写获取文章信息
  // vm.get = function() {
  //   var self = this,
  //       defer = $.Deferred();
  //   smarket.api.article.get(self.articleId, 1, 1, 1, smarket.urlParams.ocode).then(function(data) {
  //     var result = data,
  //         content = result.content;
  //     if (result.result == '0') {
  //       self.init(content);
  //       vm.readOrigin = ko.observable(content.readOrigin);//是否阅读原文
  //       defer.resolve(data);
  //     }
  //     else {
  //       defer.reject(data);
  //     }
  //   }, function(error) {
  //     defer.reject(error);
  //   });
  //   return defer.promise();
  // };
  vm.fileList = ko.observableArray();  //文件列表
  vm.selectedFiles = ko.observableArray(); //选中的文件
  vm.selectedFilesName=ko.observableArray();//选中文件的名称
  vm.wenjianleixing=ko.observableArray();//选中文件的类型
  vm.isSelectAll = ko.observable(false);  //是否全选了
  vm.selectFile = function(file) {
    file.isSelect(!file.isSelect());
    if (file.isSelect()) {
      vm.selectedFiles().push(file.fileId);
      vm.selectedFilesName().push(file.name);
      vm.wenjianleixing().push(file.ext);
    }
    else {
      vm.selectedFiles(vm.selectedFiles().filter(function(elem) {
        return elem !== file.fileId;
      }));
    }
    vm.isSelectAll(vm.selectedFiles().length === vm.fileList().length);
    vm.canDownload(vm.selectedFiles().length > 0);
    return true;
  };  //选中文件
  vm.selectAll = function() {
    vm.isSelectAll(!vm.isSelectAll());
    var allFileId = [];
    var allFileIdName=[];
    var leixing=[];
    if (vm.isSelectAll()) {
      vm.fileList().forEach(function(data) {
        allFileId.push(data.fileId);
        allFileIdName.push(data.name)
        leixing.push(data.ext)
        data.isSelect(true);
      });
    }
    else {
      vm.fileList().forEach(function(data) {
        data.isSelect(false);
      });
    }
    vm.selectedFiles(allFileId);
    vm.selectedFilesName(allFileIdName);
    vm.wenjianleixing(leixing);
    vm.canDownload(vm.selectedFiles().length > 0);
    return true;
  };  //选中全部
  vm.canDownload = ko.observable(false);  //是否可以下载
  vm.backUrl=ko.observable('');
  vm.backShow=ko.observable(false);
  //返回按钮显示不显示
  if(smarket.urlParams.back_returnUrl){
    vm.backShow=ko.observable(true);
    vm.backUrl(decodeURIComponent(smarket.urlParams.back_returnUrl));
  }else {
    vm.backShow=ko.observable(false);
  }
  vm.backList=function(){
    window.location.href= vm.backUrl();
  };

  vm.switchModalClose = function(){
    vm.downloadModal(!vm.downloadModal());
  };
  vm.downloadModal = ko.observable(false);  //下载弹窗显示
  vm.switchModal = function() {
    if (vm.canDownload()) {

      if(!!$.cookie('user_email')){
        vm.email($.cookie('user_email'));
        console.log('$.cookie222',$.cookie('user_email'),vm.email())
      }else{
          //获取联系人
          smarket.api.filesb.getWechat({
              tenantId: tenantId,
              weChatId: smarket.urlParams.weChatId,
              isAuthorize:1
          }).then(function (data) {
              if(data.result==0){
                  smarket.api.filesb.getContact({
                      tenantId: tenantId,
                      weChatId:data.content.bindWeChatId?data.content.bindWeChatId:data.content.weChatId,
                      openId: own.openId
                  }).then(function(data){
                      if(data.result==0){
                          vm.email(data.content.email);
                          $.cookie('user_email', vm.email(), {path: '/', domain: ''});
                      }else{
                          vm.email('');
                      }
                  })

              }else{
                  vm.email('');
              }
          })

        //获取联系人
        //smarket.api.filesb.getContact({
        //  tenantId: tenantId,
        //  openId: own.openId
        //}).then(function (data) {
        //  if(data.result==0){
        //    vm.email(data.content.email);
        //      $.cookie('user_email', vm.email(), {path: '/', domain: ''});
        //  }else{
        //    vm.email('');
        //  }
        //})
      }

      //vm.email('');
      vm.downloadModal(!vm.downloadModal());
    }
  };  //下载弹窗状态切换
  vm.email = ko.observable('');  //邮箱
  vm.errorTip = ko.observable(false);  //错误提示显示
  vm.errorTipText = ko.observable('');  //错误提示文字
  vm.Prevent=ko.observable(true);//防止多次提交
  vm.send = function() {
      if(!vm.Prevent()){
          return
      }
    if (vm.email() === '') {
      vm.errorTip(true);
      vm.errorTipText('请填写email');
      return false;
    }
    else if (!/^([a-zA-Z0-9_\.\-])+@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(vm.email())) {
      vm.errorTip(true);
      vm.errorTipText('请填写正确的邮箱');
      return false;
    }
    else {
      vm.errorTip(false);
    }
      function addBowerInfo(url, data) {
          if (!('sess' in data)) {
              data.sess = own.session
          }
      }
      var urlItems = ['/file/downloadWithEmail'];
      smarket.registerRulesListHandler(addBowerInfo, urlItems);
      vm.Prevent(false)
    smarket.api.file.downloadWithEmail(vm.email(), vm.selectedFiles(), own.globalUserId, own.openId, articleId, 0,
        location.href, moduleId, articleContent.instanceId,{
        tenantId: tenantId,
        instanceId: instanceId,
        memberId: own.memberId,
        moduleId: moduleId,
        openId: own.openId,
        weChatId: unusedWeChatId,
        objInstanceId: unusedWeChatId,
        browseInfo:activeRecord.browseInfo,
        source:'WAP'
      }).then(function(data) {
      vm.downloadTipModal(true);
      if (Number(data.result) === 0) {
          vm.Prevent(true)
        vm.fileList().forEach(function(data) {
          if(data.isSelect()){
            //下载是否审核 1开启 0关闭
            if (data.isReview == 1) {
              vm.downloadTipTitle('申请已提交');
              vm.downloadTipContent('审核通过后可从邮件中下载');
            } else {
              vm.downloadTipTitle('已下载成功');
              vm.downloadTipContent('稍后请查看您的邮箱');
            }
          }
        });
        //vm.downloadTipTitle('已下载成功');
        //vm.downloadTipContent('稍后请查看您的邮箱');
        //for(var i=0;i<vm.selectedFiles().length;i++){
        //  activeRecord.on('browse',function(){
        //
        //  }, {
        //    tenantId: tenantId,
        //    instanceId: instanceId,
        //    moduleId: moduleId,
        //    title: articleContent.title,
        //    session: own.session,
        //    memberId: own.memberId,
        //    summary: articleContent.summary,
        //    coverImageUrl: articleContent.shareImageUrl,
        //    url: window.location.href,
        //    openId: own.openId,
        //    weChatId: unusedWeChatId,
        //    objInstanceId: unusedWeChatId,
        //    objId: vm.selectedFiles()[i],
        //    objTitle: vm.selectedFilesName()[i]+'.'+vm.wenjianleixing()[i],
        //    actionKey: 'file_email',
        //    shareSuccessCallback: function() {
        //
        //    },
        //    shareCancelCallback: function() {
        //
        //    }
        //  })
        //}
      }
      else {
        vm.downloadTipTitle('下载失败');
        vm.downloadTipContent(data.desc);
      }
      //初始化
        $.cookie('user_email', vm.email(), {path: '/', domain: ''});
      vm.switchModalClose();
      //vm.switchModal();
      vm.isSelectAll(true);
      vm.selectAll();
    });
  };  //发送功能

  vm.downloadTipModal = ko.observable(false);  //发送后提示弹窗
  vm.downloadTipTitle = ko.observable('已下载成功');  //发送后提示弹窗文字
  vm.downloadTipContent = ko.observable('稍后请查看您的邮箱');  //下载后提示内容
  function showPage() {
    if(vm.isWeChat()&&smarket.urlParams.marketingTaskId){
      setTitle('任务详情');
    }else if(smarket.urlParams.pageTitle){
      setTitle(smarket.urlParams.pageTitle);
    }else {
      if(articleContent.title){
        setTitle(articleContent.title);
      }
    }

    $s_temp.loading.hide();
//    $('title').text(smarket.urlParams.pageTitle || articleContent.title);
    if (!!smarket.urlParams.configId) {
      console.log(actionKey1)
      $('[loading="page"]').show();
      //smarket.template.renderByConfigId('article', articleContent.templateConfigId).then(function(config) {
      //  if(!(smarket.isUrl(config.formalUrl) && window.location.href.indexOf(config.formalUrl) < 0)){
      //      // activeRecord.on('browse',function(){
      //      //     if (Number(articleContent.useLinkUrl) === 1) {
      //      //         location.href = articleContent.linkUrl;
      //      //     }
      //      // },{
      //      //     tenantId:tenantId,
      //      //     moduleId:moduleId,
      //      //     session:own.session,
      //      //     instanceId:instanceId,
      //      //     memberId:own.memberId,
      //      //     openId:own.openId,
      //      //     weChatId:unusedWeChatId,
      //      //     objId:articleId,
      //      //     objInstanceId:unusedWeChatId,
      //      //     objTitle:articleContent.title,
      //      //     actionKey:actionKey1,
      //      // });
      //      // // 浏览统计
      //      //smarket.api.article.browse(articleId, own.session, own.globalUserId, own.openId, location.href, document.referrer,
      //      //    new UAParser().getResult(), articleContent.title, unusedWeChatId, window.screen.width + '*'
      //      //    + window.screen.height).then(function() {
      //      //});
      //  }
      //});
    }
    else {
      $('[loading="page"]').show();
    }
   setTimeout(function () {
     var editContentImages=   document.getElementById('editContent').getElementsByTagName("img");
     var imagesUrls=[];
     for (var i=0;i<editContentImages.length;i++){
       imagesUrls.push(editContentImages[i].src);
       $(editContentImages[i]).off().on('click',function (event) {
         var previewImageConfigs={
           current:event.currentTarget.src,
           urls:imagesUrls,
         };
         window.$swxsdk.wx.previewImage(previewImageConfigs);
       });
     }
   },1000);
  }
  function setTitle (t) {
    document.title = t;
  }

  function checkWeChatId(weChatId1) {
    var defer = $.Deferred(),
        used = false;
    /**
     * 如果url里有ocode，就使用url里的weChatId
     * 其次通过源weChatId获取微信信息，并使用bindWeChatId
     * 源weChatId为0时，如果开启了显授权，就使用显授权的weChatId
     * 源weChatId为0且url有weChatId时，仅使用url里的weChatId
     * 如果未开启显授权，仅使用默认weChatId做分享操作
     */
    if (smarket.urlParams.ocode) { // 有ocode的情况下，应用url的weChatId
      smarket.api.wechat.getAppId(smarket.urlParams.weChatId).then(function(data) {
        var content = data.content;
        defer.resolve(content.bindWeChatId);
      });
      used = true;
    }
    if (weChatId1&&weChatId1 != 0) { // 文章为实例下的时候
      unusedWeChatId = weChatId1;
      if (!used) {
        smarket.api.wechat.getAppId(weChatId1).then(function(data) {
          var content = data.content;
          defer.resolve(content.bindWeChatId);
        });
      }
    }
    else if (smarket.urlParams.weChatId) { // 文章为全局下的，没有开启显授权，但是url里有weChatId
      unusedWeChatId = smarket.urlParams.weChatId;
      if (!used) {
        smarket.api.wechat.getAppId(smarket.urlParams.weChatId).then(function(data) {
          var content = data.content;
          defer.resolve(content.bindWeChatId);
        });
      }
    }
    else { // 什么都没有
      unusedWeChatId = 0;
      if (!used) {
        defer.resolve(0);
      }
    }
    return defer.promise();
  }

  function initAfterPage(res) {
    smarket.Config.extend({tenantId: res.tenantId});
    own.globalUserId = smarket.cookie.globalUserId();
    vm.tenantId(res.tenantId);
    tenantId = res.tenantId;
    instanceId = res.instanceId;
    moduleId = res.moduleId;
    if (!!smarket.urlParams.configId) {
      smarket.template.renderByConfigId('article').done(function(config) {
        console.log(122)
        if (smarket.isUrl(config.formalUrl) && config.formalUrl.indexOf(window.location.pathname) < 0 && false){

        }else{
          vm.load().then(function(data) {
            articleContent = data.content;
            realWeChatId = articleContent.weChatId;
            // tenantId=data.content.tenantId;
            // instanceId=data.content.instanceId;
            // moduleId=data.content.moduleId;
            articleContent.tenantId = vm.tenantId();
            articleContent.instanceId = instanceId;
            articleContent.moduleId = moduleId;
            var authorisedType = articleContent.authorisedType == 1 ? 'snsapi_userinfo':'snsapi_base';  // 文章显授权设置
            vm.readOrigin = ko.observable(articleContent.readOrigin);//是否阅读原文
            //ko.applyBindings(vm);
            // smarket.template.renderByConfigId('article', articleContent.templateConfigId).then(function(config) {
            //   configSet=config.categoryId;
            // });

            // 获取统计信息
            // vm.getDynamicInfo().then(function(caonima){
            //   // vm.likeCount(caonima.statInfo ? caonima.statInfo.likeCount : 0);
            // });

            // 判断加载文件列表
            if (!!articleContent.fileIds) {
              articleContent.fileIds = articleContent.fileIds.split('|');
            }
            if (articleContent.fileIds instanceof Array) {
              smarket.api.file.getListForWeChat(articleContent.fileIds).then(function(data) {
                var files = data.content;
                files.forEach(function(item) {
                  item.category = filter.fileType(item.ext);
                  item.isSelect = ko.observable(false);
                });
                vm.fileList(files);
              });
            }

            return checkWeChatId(articleContent.weChatId).then(function(usedWeChatId) {
              weChatId =usedWeChatId;
              var defer = $.Deferred();
              var memberInfo='';

              memberInfo = smarket.cookie.smarketMember(articleContent.schemaId);
              if (!memberInfo) {
                memberInfo = smarket.cookie.smarketMember(0);//不知道为什么这么写，保留
              }
              if (memberInfo) {
                own.session = memberInfo.session;
                own.memberId=memberInfo.memberInfo;
              }

              if(weChatId==0 || weChatId=='undefined' || weChatId==undefined){
                memberInfo = smarket.cookie.smarketMember(articleContent.schemaId);
                if (memberInfo) {
                  own.session = memberInfo.session;
                  own.memberId=memberInfo.memberInfo;
                }
                defer.resolve();
              }else{
                //订阅号
                if (smarket.urlParams.openId) {
                  own.openId = smarket.urlParams.openId;
                  //defer.resolve();
                }
                if(smarket.inWeChat) {
                  //清除粉丝cookie
                  //   for(var i in $.cookie()){
                  //   if(i.indexOf('verifyInfo')>-1){
                  //     smarket.cookie.verify.remove(i.split('_')[1]);
                  //     smarket.cookie.verifyInfo.remove(i.split('_')[1]);
                  //   }
                  // }
                  if( smarket.cookie.verify(weChatId)&&smarket.cookie.verifyInfo(weChatId)){
                    var tenkentInfo=smarket.cookie.verifyInfo(weChatId);
                    own.headimgurl = tenkentInfo.avatar ? tenkentInfo.avatar : '';
                    own.openId = tenkentInfo.providerId ? tenkentInfo.providerId : '';
                    own.nickname = tenkentInfo.nickname ? tenkentInfo.nickname : '';
                    defer.resolve();
                  }else {
                    return     smarket.getUserInfoByToken(weChatId, authorisedType).then(function (data) {
                      if(data.tokenInfo){
                        own.headimgurl = data.tokenInfo.avatar ? data.tokenInfo.avatar : '';
                        own.openId = data.tokenInfo.providerId ? data.tokenInfo.providerId : smarket.urlParams.openId ? smarket.urlParams.openId : '';
                        own.nickname = data.tokenInfo.nickname ? data.tokenInfo.nickname : '';
                      }
                      else{
                        window.location.href = weChatId ? window.config.weChatOauthUrl + '?weChatId=' + weChatId +
                          '&scope=' + authorisedType + '&return_url=' + encodeURIComponent(smarket.removeParam(window.location.href.split('#')[0],
                            'excode', 'retCode', 'puzzleFlag','marketingTaskId','fullMarketPageUrl')) : window.location.href.split('#')[0]
                      }
                      memberInfo = smarket.cookie.smarketMember(articleContent.schemaId);
                      if (memberInfo) {
                        own.session = memberInfo.session;
                        own.memberId = memberInfo.memberInfo;
                      }
                      defer.resolve();
                    },function(){

                      defer.resolve();
                      return defer.promise();
                    })
                  }
                }else{

                  defer.resolve();
                }

                //}
              }
              return defer.promise();
            },function(){
              var memberInfo = smarket.cookie.smarketMember(articleContent.schemaId);
              if (!memberInfo) {
                memberInfo = smarket.cookie.smarketMember(0);//不知道为什么这么写，保留
              }
              if (memberInfo) {
                own.session = memberInfo.session;
                own.memberId=memberInfo.memberInfo;
              }
            });
          })
          .then(function() {
            //全员营销模板分享使用
            //window.parent.postMessage({fullMarket:{
            //  articleContent:articleContent,
            //  unusedWeChatId:unusedWeChatId,
            //  shareSuccessParam:{
            //    tenantId:tenantId,
            //    articleId:articleId,
            //    source:'WAP',
            //    interactionType:2,
            //    globalUserId:own.globalUserId,
            //    sess:own.session,
            //    openId:own.openId,
            //    currentUrl:window.location.href,
            //    weChatId:realWeChatId ==0?unusedWeChatId:realWeChatId,
            //    marketingSess: $.cookie('marketingSess'),
            //    browseInfo:activeRecord.browseInfo
            //  }
            //}},'*');
            var defer = $.Deferred();
            smarket.initForm({
              identity: articleContent.identity,//参与方式后来修改了获取的 api接口 里面的值变了
              weChatId: weChatId,
              formId: articleContent.registerFormId,//新的参数 换名字了
              trackId: articleContent.trackId,
              schemaId: articleContent.schemaId,
              instanceId: articleContent.instanceId,
              attentionWeChat:weChatId,
              type: 'wap',
              extraConfig: articleContent.extraConfig,
              tenantId: articleContent.tenantId,
              meetingInstanceId: articleContent.meetingInstanceId,
              meetingType: articleContent.meetingType,
              preview: true,
              moduleId: articleContent.moduleId
            }, function(result, preData) {
              console.log(result);
              if(!(Number(articleContent.useLinkUrl) === 1)){
                showPage();
              }
              smarket.api.article.browse(articleId, own.session, own.globalUserId, own.openId, location.href, document.referrer,
                new UAParser().getResult(), articleContent.title, unusedWeChatId, window.screen.width + '*'
                + window.screen.height).then(function() {
                if (Number(articleContent.useLinkUrl) === 1 && vm.content() == '') {
                  location.replace(articleContent.linkUrl);

                }else{

                  showPage();
                }
              });
            });

            /** 微信分享设置 */
            console.log('微信JSSDK库：', window.$swxsdk);
            var wd = (!realWeChatId || realWeChatId == '0') ? unusedWeChatId : realWeChatId;
            if(!wd || wd == '0'){
              wd = null;
            }
            var sharedurl = smarket.removeParam(articleContent.authUrl, 'return_url');
            var hurl = encodeURIComponent(smarket.removeParam(window.location.href.split('#')[0],'token', 'excode','retCode','puzzleFlag','marketingTaskId','fullMarketPageUrl'));
            sharedurl = smarket.updateParam('return_url', hurl, sharedurl);
            var sconf = {
              title: articleContent.shareTitle === '' ? articleContent.title : articleContent.shareTitle,
              desc: articleContent.shareDesc === '' ? articleContent.summary : articleContent.shareDesc,
              link: sharedurl,
              imgUrl: articleContent.shareImageRealPath ? window.location.protocol + '//' + articleContent.shareImageRealPath.split('//')[1] : ''
            };
            var isAll = Number(articleContent.shareState) === 0;
            var hideArr = isAll ? [
              'menuItem:share:appMessage',
              'menuItem:share:timeline',
              'menuItem:share:qq',
              'menuItem:share:QZone',
              'menuItem:copyUrl',
              'menuItem:share:brand',
              'menuItem:openWithQQBrowser',
              'menuItem:openWithSafari',
              'menuItem:favorite'
            ] : ['menuItem:favorite'];
            window.$swxsdk.initWxSdk({
              tenantId: tenantId,
              weChatId: wd,
              jsApiList: [
                'onMenuShareAppMessage',
                'onMenuShareTimeline',
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'hideMenuItems',
                'hideAllNonBaseMenuItem',
                'showMenuItems',
                'previewImage',
                'showAllNonBaseMenuItem'
              ],
              url: window.location.href.split('#')[0]
            });
            window.$swxsdk.on("sharer", sconf);
            window.$swxsdk.on("sharer_friends", sconf);
            window.$swxsdk.on("hideMenuList", {menuList: hideArr});
            if(isAll){
              window.$swxsdk.on("hideOptionMenu");
            }
            ko.applyBindings(vm);
            //ueditor图片背景
            var cbg = $("#editContent p[data-background]:hidden");
            if(cbg.length>0)
              $("#editContent ").attr("style", cbg.attr("data-background"));
            defer.resolve();
            return defer.promise();
          })
        }
      })
    }

  }
  function initPage() {
    if(window.$s_temp.jsonParams){
      initAfterPage(window.$s_temp.jsonParams);
    }
    window.$s_temp.watch = function(c){
      if(c.type === 'jsonParams'){
        initAfterPage(c.data);
      }
    };
  }



  // // 判断是否存在 cookieId ，执行页面初始化
  if (!smarket.cookie.globalUserId()) {
    smarket.api.account.getGlobalUserId().then(initPage);
  }
  else {
    initPage()
  }
})(smarket, ko, $);